function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

var prefix = '$$_computed_';
function injectComputedMiddleware(f) {
  return function (set, get, api) {
    var _st$prefix;
    var setWithComputed = function setWithComputed(update, replace) {
      set(function (state) {
        var _state$prefix;
        var updated = typeof update === 'object' ? update : update(state);
        var computedSt = (_state$prefix = state[prefix]) == null ? void 0 : _state$prefix.call(state, updated);
        return _extends({}, state, updated, computedSt);
      }, replace);
    };
    api.setState = setWithComputed;
    var st = f(setWithComputed, get, api);
    var computedSt = (_st$prefix = st[prefix]) == null ? void 0 : _st$prefix.call(st, st);
    return Object.assign({}, st, computedSt);
  };
}
function compute(
// @ts-ignore
get, fn) {
  var _ref;
  return _ref = {}, _ref[prefix] = fn, _ref;
}
var computed = function computed(f) {
  return injectComputedMiddleware(f);
};

export { compute, computed };
//# sourceMappingURL=zustand-computed-state.esm.js.map
